export {
  TooltipComponent,
  TooltipPosition,
  TooltipSize,
} from './tooltip.component';
